import React, { useEffect, useState } from "react";
import { useLocation } from "@reach/router";
import Header from "./header";
import Footer from "./footer";
import logo from "../assets/logos/logo-agency.svg";
import { Link } from "gatsby";
import LanguageSwitcher from "./LanguageSwitcher";
import { cn } from "../util";
import "../styles/global.scss";
import { prependLocale } from "../i18n/prepend-locale";

const Layout = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMacOS, setIsMacOS] = useState(false);
  const [isSafari, setIsSafari] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsVisible(true);
    // Detect macOS
    setIsMacOS(navigator.platform.toUpperCase().indexOf("MAC") >= 0);
    // Detect Safari
    setIsSafari(/^((?!chrome|android).)*safari/i.test(navigator.userAgent));
  }, [location.pathname]);

  return (
    <div
      className={cn(
        `transition-opacity duration-500 ${isVisible ? "opacity-100" : "opacity-0"}`,
      )}
    >
      <Header />
      <nav
        className={cn(
          "absolute hidden origin-top-left items-center",
          "justify-between md:fixed md:flex",
          "md:w-[100vh] md:rotate-90 md:px-[30vh]",
          "z-50",
          isMacOS && isSafari ? "md:left-[calc(100%-1rem)]" : "md:left-full",
        )}
      >
        <Link to={prependLocale("/")}>
          <img src={logo} alt="Agency Logo" className={cn("w-[70px]")} />
        </Link>
        <LanguageSwitcher />
      </nav>
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
